import { getEnvironmentAwareBaseURL } from 'services/globals';

export const FUNDING_METHODS = {
  CHECK: 'CHECK',
  ACH: 'ACH',
  EXCHANGE: 'EXCHANGE',
  NONE: 'NONE',
  TRANSFER: 'TRANSFER',
  DIRECT_ROLLOVER: 'DIRECT_ROLLOVER',
  INDIRECT_ROLLOVER: 'INDIRECT_ROLLOVER'
};

export const MAINTENANCE_METHODS = {
  RECURRING_BUY: 'RECURRING_BUY',
  BROKERAGE_TRADING: 'BROKERAGE_TRADING',
  BENEFICIARY: 'BENEFICIARY',
  TRUSTED_CONTACT: 'TRUSTED_CONTACT'
};

export const ONBOARDING_CTA = {
  ACH: {
    label: 'Buy Shares',
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/buy?productType=MutualFund&?selectedAgreementIDs=`
  },
  EXCHANGE: {
    label: 'Exchange Shares',
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/exchange`
  },
  TRANSFER: {
    label: 'Start My Transfer',
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/funding/transfer?selectedAgreementID=`
  },
  DIRECT_ROLLOVER: {
    label: 'Start My Rollover',
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/funding/rollover?selectedAgreementID=`
  },
  INDIRECT_ROLLOVER: {
    label: 'Start My Rollover',
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/funding/rollover?selectedAgreementID=`
  },
  CHECK: {
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/funding/mail-check?selectedAgreementID=`
  },
  RECURRING_BUY: {
    navigation: `${getEnvironmentAwareBaseURL()}/usis/transactions/automatic/buy`
  }
};

// before starting SSJ
export const handleSSJNav = (onboardingKey, account) => {
  const { accountId } = account;
  if (
    !accountId ||
    !onboardingKey ||
    !ONBOARDING_CTA[onboardingKey] ||
    !ONBOARDING_CTA[onboardingKey].navigation
  ) {
    return null;
  }
  if (
    onboardingKey === FUNDING_METHODS.EXCHANGE ||
    onboardingKey === MAINTENANCE_METHODS.RECURRING_BUY
  ) {
    return (window.location.href = `${ONBOARDING_CTA[onboardingKey].navigation}`);
  }
  return (window.location.href = `${ONBOARDING_CTA[onboardingKey].navigation}${accountId}`);
};

// after completing SSJ
export const confirmSubmissionNav = (onboardingKey, account) => {
  const { accountId } = account;
  if (
    !accountId ||
    !onboardingKey ||
    !ONBOARDING_CTA[onboardingKey] ||
    !ONBOARDING_CTA[onboardingKey].navigation
  ) {
    return null;
  }
  if (
    onboardingKey === FUNDING_METHODS.EXCHANGE ||
    onboardingKey === FUNDING_METHODS.ACH
  ) {
    return (window.location.href = `${getEnvironmentAwareBaseURL()}/usis/my-accounts/transactions`);
  }
  return handleSSJNav(onboardingKey, account);
};
